module.exports = __webpack_public_path__ + "img/15.dc4c07c5.svg";